import { render, staticRenderFns } from "./show.vue?vue&type=template&id=d0d08bca&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"
import style0 from "./show.vue?vue&type=style&index=0&id=d0d08bca&prod&lang=scss"
import style1 from "./show.vue?vue&type=style&index=1&id=d0d08bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d08bca",
  null
  
)

export default component.exports